
import React, { useState } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';
import styles from './styles.module.scss';
import EditableText from "@/components/EditableText";
import EditableImage from "@/components/EditableImage";
import clsx from "classnames";
import PropTypes from "prop-types";

export default function TileCard({
    className,
    post,
    with_hyperlink
}) {


    return (
        <Card className={`${clsx(className, styles.root)} ${post.image ? "with-image" : "no-image"}`}>
            {post.image && (
                <div className='image-wrapper'>
                    <EditableImage
                        className={`mb-3`}
                        img={`${post?.image ? post.image : "/site-assets/images/img-placeholder.jpg"}`}
                        size={"x200"}
                        alt={`${post.title}`}
                        height={`100%`}
                    />
                </div>
            )}
            {with_hyperlink ?
                <div className='post-title'><a href={`${post?.url}`} target="_self">{post.title} </a></div>
                :
                <div className='post-title'>{post.title}</div>
            }
            {post.content && (
                <div className='post-content' dangerouslySetInnerHTML={{ __html: post.content }} />
            )}
        </Card>
    )
}
TileCard.defaultProps = {
    pathPrefix: "",
    className: "p-4",
};

TileCard.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
};